// finance
// export const SET_FINANCE_MESSAGE_LIST = 'SET_FINANCE_MESSAGE_LIST'
export const SET_INVOICE_EXPORTING = 'SET_INVOICE_EXPORTING'
export const SET_STATISTICS_SEARCHING = 'SET_STATISTICS_SEARCHING'

// bill
export const SET_SUBJECT_LIST = 'SET_SUBJECT_LIST'
export const SET_COMPANY_LIST = 'SET_COMPANY_LIST'
export const SET_MANAGER = 'SET_MANAGER'
